import { Component, Input, TemplateRef, ChangeDetectionStrategy } from "@angular/core";
import { ISearchResponseRow, ISearchResultRenderer } from "../../quick-search.models";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-handelssortiment-renderer",
    templateUrl: "./handelssortiment-renderer.component.html",
    styleUrls: [
        "./handelssortiment-renderer.component.scss",
        "../default-renderer.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbPopover]
})
export class HandelssortimentRendererComponent implements ISearchResultRenderer {
    @Input() input: ISearchResponseRow;
    @Input() tooltipTemplate: TemplateRef<any>;
}
